import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerSalesContractListService = {
  async save(payload, code) {
    // eslint-disable-next-line no-debugger
    // debugger;
    const url = `api/Save_CustomerSalesContract`;
    if (code) {
      return await ApiService.put(url, code, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },
  dataSourceConfig(url, params) {
    //  var url = "api/CustomerSalesContractList";

    // eslint-disable-next-line no-debugger
    // debugger;
    return ApiService.createDataSource(url, params);
  },
};

export { CustomerSalesContractListService };
